module.exports = __webpack_public_path__ + "static/media/rsr-logo.26bdf1df.svg";